/**
 * /diagnostic — layout route.
 *
 * Renders nothing itself; delegates to child routes via <Outlet/>:
 *   /diagnostic/         → DiagnosticIndex (wizard)  — see diagnostic.index.tsx
 *   /diagnostic/results  → ResultsPage               — see diagnostic.results.tsx
 *
 * Previously this file rendered the wizard directly AND claimed the layout
 * slot, which meant every /diagnostic/* URL rendered the wizard instead of
 * the intended child. Split fixed that.
 */

import { createFileRoute, Outlet } from '@tanstack/react-router';

export const Route = createFileRoute('/diagnostic')({
  component: DiagnosticLayout,
});

function DiagnosticLayout() {
  return <Outlet />;
}
